import { render } from "./FixedPage.vue?vue&type=template&id=267a2226&scoped=true"
import script from "./FixedPage.vue?vue&type=script&lang=js"
export * from "./FixedPage.vue?vue&type=script&lang=js"

import "./FixedPage.vue?vue&type=style&index=0&id=267a2226&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267a2226"]])

export default __exports__